<template>
    <div class="investment">
        <div class="header">

          <div class="t-left">
            CASE
          </div>
          <div class="t-right">
            <div>
              行业案例
            </div>
            <div>
              INDUSTRY CASE
            </div>
          </div>



        </div>


        <div class="case-wrap">

          <div class="case-box clearfix">
            <div class="case-list fl">
                <div class="case-package">
                  <div class="case-top">
                      <div class="case-title">
                        温州艺品天下
                      </div>
                      <div class="case-time">
                        2021-12-03
                      </div>
                      <div class="case-synopsis">
                        温州当地最大型的红木、翡翠零售商，选用有源RFID实时监控方案，解决非标商品销售痛点，实现在线库存、实时监控，智能分析客户及销售数据，提升销售业绩。
                      </div>
                  </div>
                  <div class="case-img">
                    <img src="../assets/Investment/c1.jpg" alt="">
                  </div>
                </div>
            </div>
            <div class="case-list fl">
                <div class="case-package">
                  <div class="case-top">
                      <div class="case-title">
                        平洲翡翠艺术馆
                      </div>
                      <div class="case-time">
                        2021-12-03
                      </div>
                      <div class="case-synopsis">
                        佛山大型翡翠艺术展馆，采用有源RFID实时监控方案，解决展馆库存管理问题，提高效率，减少出错率，并大幅加强展品安全系数
                      </div>
                  </div>
                  <div class="case-img">
                    <img src="../assets/Investment/c2.jpg" alt="">
                  </div>
                </div>
            </div>
            <div class="case-list fl">
                <div class="case-package">
                  <div class="case-top">
                      <div class="case-title">
                        平洲翡翠直播基地
                      </div>
                      <div class="case-time">
                        2021-12-03
                      </div>
                      <div class="case-synopsis">
                        基地采用最新的借货直播模式，有着货流量大，单价高、商品非标等特点，选用无源RFID方案，无缝对接存管方、供货商、主播三方业务。
                      </div>
                  </div>
                  <div class="case-img">
                    <img src="../assets/Investment/c3.jpg" alt="">
                  </div>
                </div>
            </div>
           
          
         




            
          </div>





        </div>





    </div>

</template>
<script>
  export default {
    name: "investment",
    data(){
      return{
       
      }
    },
    mounted(){
    },
    methods:{
      juTo(){
        this.$router.push('/investmentDetails');
      }
    },
    created:function(){

    },
    watch:{

    },
  }
</script>

<style scoped>
.investment{
  padding-bottom: 108px;
}


.header{
  width: 1160px;
  margin: 96px auto;
  position: relative;
}
.header:after{ 
  content:"";
  width: 9000px;
  height: 2px;
  background: #000000;
  position: absolute;
  bottom: 0;
  left: -8678px;
}
.t-left,.t-right{
  display: inline-block;
  vertical-align: middle;
}
.t-left{
  font-size: 60px;
  color: #3575E1;
  margin-left: 50px;
}
.t-right div:nth-child(1){
  font-size: 30px;
  color: #000000;
}
.t-right div:nth-child(2){
  font-size: 14px;
  color: #999999;
}
/* .header */
.case-wrap{
  margin-top: 50px;
}
.case-box{
  width: 1200px;
  margin: 0 auto;
  text-align: left;
}

.case-list{
  /* width: 33.3333%; */
  width: 33.3333%;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-size: 0;
  margin-bottom: 20px;
}
.case-package{
  box-shadow: 0px 0px 10px rgba(34, 31, 31, 0.5);
  width: 80%;
  margin: 0 auto;
}
.case-top{
  padding: 20px;
}

.case-title{
  font-size: 20px;
  color: #333333;
}
.case-time{
  font-size: 14px;
  color: #999999;
  margin-top: 25px;
  margin-bottom: 33px;
}
.case-synopsis{
  font-size: 18px;
  color: #666666;
  height: 120px;
}
.case-img img{
  display: block;
  width: 100%;
}








</style>



// WEBPACK FOOTER //
// src/components/investment.vue